import { render, staticRenderFns } from "./LabChallenges.vue?vue&type=template&id=24c720d8&scoped=true&"
import script from "./LabChallenges.vue?vue&type=script&lang=ts&"
export * from "./LabChallenges.vue?vue&type=script&lang=ts&"
import style0 from "@/markdown.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./LabChallenges.vue?vue&type=style&index=1&id=24c720d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c720d8",
  null
  
)

export default component.exports